import title from './title.js';

export default dsf.component({
  name: 'DsfTitle6',
  mixins: [title],
  ctrlCaption: "六级标题",
  props: {
    value: {
      type: [String, Number],
      default: '标题6'
    },
    fontType: {
      type: Number,
      default: 6
    }
  }
});